import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import PhoneSupport from './PhoneSupport';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PhoneSupportPlanBuilder = ({
  phoneSourceId,
  screen,
  apiName
}) => {
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsxs(Flex, {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-100",
        "data-selenium-id": "phone-support-header",
        textAlign: "center",
        marginBlock: "200",
        marginBlockEnd: "300",
        display: "block",
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.phone-supportV2.needHelp"
        })
      }), /*#__PURE__*/_jsx(PhoneSupport, {
        phoneSourceId: phoneSourceId,
        screen: screen,
        apiName: apiName
      })]
    })
  });
};
export default PhoneSupportPlanBuilder;